import { cn } from '@tripleten/cn';

export const cnOpenGmailButton = cn('open-gmail-button');
